import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import applicantApi from "@/lib/applicantApi";

const Ctx = createContext(null);

export const ApplicantAuthProvider = ({ children }) => {
  const [applicant, setApplicant] = useState(null);
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("ca_applicant_token");
    if (!token) {
      setApplicant(false);
      setChecking(false);
      return;
    }
    try {
      const { data } = await applicantApi.get("/applicants/me");
      setApplicant(data);
    } catch {
      localStorage.removeItem("ca_applicant_token");
      setApplicant(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const register = async (payload) => {
    const { data } = await applicantApi.post("/applicants/register", payload);
    localStorage.setItem("ca_applicant_token", data.access_token);
    setApplicant(data.applicant);
    return data.applicant;
  };

  const login = async (email, password) => {
    const { data } = await applicantApi.post("/applicants/login", { email, password });
    localStorage.setItem("ca_applicant_token", data.access_token);
    setApplicant(data.applicant);
    return data.applicant;
  };

  const logout = () => {
    localStorage.removeItem("ca_applicant_token");
    setApplicant(false);
  };

  return (
    <Ctx.Provider value={{ applicant, checking, register, login, logout, refresh, setApplicant }}>
      {children}
    </Ctx.Provider>
  );
};

export const useApplicantAuth = () => {
  const c = useContext(Ctx);
  if (!c) throw new Error("useApplicantAuth outside provider");
  return c;
};
